import React from 'react';
import styles from "./styles.module.css";

const Header: React.FC = () => {
    return (
        <div className={styles.rodape}>
            <p>NANDA CONFEITOS TODOS OS DIREITOS RESERVADOS</p>
            <p>CRIADO POR MVP SOLUTIONS</p>
        </div>

    )
}

export default Header;